export default "__VITE_ASSET__BfYTWJUQ__";